import { useProfile } from 'src/utils/customHook';

const useCookie = () => {
  const profile = useProfile()


  
  const setCookie = async (name:string,value:any,days:number,belongToUser:boolean = false) => {
    var expires = "";

    if (belongToUser) {
      const investorID = profile?.investorId
      name = investorID+name
      // name = Buffer.from(investorID+name).toString("base64")
      // value = Buffer.from(value).toString("base64")
    }

    name = Buffer.from(name).toString("base64")
    name = name.slice(0,8) + name.slice(-4)

    value = Buffer.from(value).toString("base64")

    if (days) {
      var date = new Date();
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
      expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "") + expires + "; path=/";
  }

  const getCookie = (name:string,belongToUser:boolean = false) => {

    if (belongToUser) {
      const investorID = profile?.investorId
      // name = Buffer.from(investorID+name).toString("base64")
      name = investorID+name
    }

    name = Buffer.from(name).toString("base64")
    name = name.slice(0,8) + name.slice(-4)

    var nameEQ = name + "=";
    var ca = document.cookie.split(";");
    var value = ""
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) === " ") c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) === 0) {
        value = c.substring(nameEQ.length, c.length);
        return Buffer.from(value,"base64").toString("ascii")
      }
    }
    return null;
  }

  const eraseCookie = (name:string,belongToUser:boolean = false) => {

    if (belongToUser) {
      const investorID = profile?.investorId
      name = Buffer.from(investorID+name).toString("base64")
    }

    name = name.slice(0,8) + name.slice(-4)

    document.cookie = name + "=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;";
  }

  const hook = {
    setCookie:setCookie,
    getCookie:getCookie,
    eraseCookie:eraseCookie,
  }

  return hook

}

export default useCookie;